import React, { useEffect, useState } from "react";
import { getCampaignWeeklyStats } from "../../../action_managers/campaigns";
import isEmpty from "lodash/isEmpty";
import { useDispatch } from "react-redux";
import papa from "papaparse";
import { downloadFile } from "../../lib/download_file";
import uniq from "lodash/uniq";
import zipWith from "lodash/zipWith";
import concat from "lodash/concat";

/*
  CSV should like like the following,

  Show Title,          2020-04-27, 2019-05-22
  In the Lobby,        10,         0
  Emily's Whacky Show, 0,          200
 */
const downloadCSV = (campaign, showStatsByWeek) => {
  if (!campaign) return;
  if (isEmpty(showStatsByWeek)) return;

  const weeks = Object.keys(showStatsByWeek);
  weeks.sort();
  // fields are the header columns of the csv
  // ex. Show Title, 2019-04-02, 2019-04-16, ...
  let fields = ["Show Title"].concat(weeks);
  const showTitles = uniq(
    Object.values(showStatsByWeek).flatMap(shows => shows.map(show => show.showTitle))
  );

  let data = showTitles.map(showTitle => [showTitle]);
  weeks.forEach(week => {
    const nextRow = new Array(showTitles.length).fill(0);

    const showStats = showStatsByWeek[week];
    showStats.forEach(show => {
      const index = showTitles.findIndex(showTitle => showTitle === show.showTitle);
      nextRow[index] = show.downloads;
    });

    data = zipWith(data, nextRow, concat);
  });

  const csv = papa.unparse({
    fields: fields,
    data: data,
  });

  downloadFile(`${campaign.name}_AdInsertionsPerShowByWeek.csv`, csv);
};

const DownloadCampaignPerformance = props => {
  const { campaign } = props;
  const [showStatsByWeek, setShowStatsByWeek] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isEmpty(campaign)) {
      dispatch(getCampaignWeeklyStats(campaign.uuid)).then(resp => {
        if (resp.status === 200) {
          setShowStatsByWeek(resp.json);
        }
      });
    }
  }, [campaign]);

  if (isEmpty(showStatsByWeek)) return null;

  return (
    <div className="fake-link m-lxxs" onClick={() => downloadCSV(campaign, showStatsByWeek)}>
      Download Insertion Info
    </div>
  );
};

export default DownloadCampaignPerformance;
